import React, { useEffect, useState } from "react";
import { supabase } from "../supabase/client";
import {
  FiLifeBuoy,
  FiUser,
  FiMapPin,
  FiMessageSquare,
  FiClock,
  FiPlus,
} from "react-icons/fi";
import "./Support.css";

const Support = () => {
  const [logs, setLogs] = useState([]);
  const [note, setNote] = useState("");
  const [targetType, setTargetType] = useState("user");
  const [targetId, setTargetId] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("support_logs")
      .select("*")
      .order("created_at", { ascending: false });

    if (!error) setLogs(data);
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!note || !targetId) return;

    setLoading(true);
    const { error } = await supabase.from("support_logs").insert([
      {
        target_type: targetType,
        target_id: targetId,
        note,
      },
    ]);

    if (!error) {
      setNote("");
      setTargetId("");
      fetchLogs();
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div className="support-container">
      <div className="page-header">
        <h2 className="page-title">
          <FiLifeBuoy /> Support & Notes
        </h2>
      </div>

      <div className="support-form-container">
        <form onSubmit={handleSubmit} className="support-form">
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">
                <span className="label-icon">
                  {targetType === "user" ? <FiUser /> : <FiMapPin />}
                </span>
                Target Type
              </label>
              <select
                value={targetType}
                onChange={(e) => setTargetType(e.target.value)}
                className="form-select"
              >
                <option value="user">User</option>
                <option value="carwash">Car Wash</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">
                <span className="label-icon">#</span>
                Target ID
              </label>
              <input
                type="text"
                value={targetId}
                onChange={(e) => setTargetId(e.target.value)}
                placeholder="User ID or Car Wash ID"
                className="form-input"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">
              <span className="label-icon">
                <FiMessageSquare />
              </span>
              Note
            </label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Enter complaint, log, or note..."
              className="form-textarea"
              rows={4}
              required
            />
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            <FiPlus /> {loading ? "Submitting..." : "Add Note"}
          </button>
        </form>
      </div>

      <div className="logs-section">
        <h3 className="section-title">
          <FiClock /> Recent Logs
        </h3>

        {loading ? (
          <div className="loading-spinner">Loading logs...</div>
        ) : logs.length > 0 ? (
          <div className="logs-list">
            {logs.map((log) => (
              <div key={log.id} className="log-card">
                <div className="log-header">
                  <span className={`log-type ${log.target_type}`}>
                    {log.target_type === "user" ? <FiUser /> : <FiMapPin />}
                    {log.target_type.toUpperCase()}
                  </span>
                  <span className="log-id">ID: {log.target_id}</span>
                  <span className="log-time">
                    {new Date(log.created_at).toLocaleString()}
                  </span>
                </div>
                <div className="log-content">{log.note}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-logs">No support logs found</div>
        )}
      </div>
    </div>
  );
};

export default Support;
